/* Informational pages only load Horizon components actually present in the DOM.
   Commerce and the theme editor retain the complete module set. */
const configuration = document.getElementById('kinea-optional-components');
if (configuration) {
  const modules = JSON.parse(configuration.textContent);
  const loading = new Set();

  function scan(root) {
    for (const { selector, url } of modules) {
      if (loading.has(url)) continue;
      if (root.matches?.(selector) || root.querySelector?.(selector)) {
        loading.add(url);
        import(url).catch((error) => {
          loading.delete(url);
          console.error('Unable to load theme component', error);
        });
      }
    }
  }

  scan(document);
  new MutationObserver((records) => {
    for (const record of records) {
      for (const node of record.addedNodes) {
        if (node.nodeType === Node.ELEMENT_NODE) scan(node);
      }
    }
  }).observe(document.body, { childList: true, subtree: true });
}
